import { Button } from '../ui/button';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useCreateToastMutation } from '../../redux/survey/survey.endpoints';
import { SurveyToast } from 'src/redux/survey/survey.types';
import ToastEditDialog from '../toasts/toast-edit-dialog';

interface AddToastBtnProps {
  extSurveyId: string;
  refetchToastData: () => void;
}

const AddToastBtn = ({ extSurveyId, refetchToastData }: AddToastBtnProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [createToast] = useCreateToastMutation();
  const [currentToast, setCurrentToast] = useState<SurveyToast | null>(null);

  const handleCreateInitialToast = async() => {
    try {
      const newToast = await createToast({
        name: 'New Toast',
        title: 'Title',
        subtitle: null,
        button_copy: null,
        button_url: null,
        image_url: null,
        pixel: null,
        custom_tag: null,
        survey: extSurveyId,
      }).unwrap();
      setCurrentToast({
        ...newToast,
        survey: extSurveyId,
      });
      setIsOpen(true);
    } catch (error) {
      console.error('Error creating initial toast:', error);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        className="w-full flex items-center justify-center gap-2 py-4"
        onClick={handleCreateInitialToast}
      >
        <Plus className="h-4 w-4" />
        Create New Toast
      </Button>

      <ToastEditDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        toast={currentToast}
        onToastUpdated={() => {
          setCurrentToast(null);
          setIsOpen(false);
          refetchToastData();
        }}
      />
    </>
  );
};

export default AddToastBtn;